import React from 'react';
import { link, iconPath } from '../../support';

export default function Help() {
    return (
        <a
            target="_blank"
            href={link}
            className="hidden sm:flex bg-white text-blue-gray-600 hover:bg-blue-gray-100 hover:text-blue-gray-700 active:bg-blue-gray-150 active:text-blue-gray-800 focus:outline-none focus-visible:ring-2 p-2 rounded-full group h-10 w-10"
        >
            <HelpIcon />
        </a>
    );
}

export function HelpIcon() {
    return (
        <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {iconPath}
        </svg>
    );
}
